import React from 'react';

import * as OrganizationActions from 'actions/OrganizationActions';
import CreateUsersModal from 'parties/users/CreateUsersModal';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';

import {Organization, Team} from './OrganizationConstants';

interface Props {
  organization: Organization;
  teams: Array<Team>;
}

export default class CreateUsersButton extends React.Component<Props> {
  _handleClick = (): void => {
    runModal(CreateUsersModal, {
      canSelectOrganizations: false,
      initialOrganizationId: this.props.organization.id,
      organizations: [this.props.organization],
      teams: this.props.teams
        ? this.props.teams.map((team) => ({...team, organization: {id: team.organizationId}}))
        : [],
      onSuccess: () => {
        OrganizationActions.fetchMembers(this.props.organization.id);
      },
    });
  };

  override render(): JSX.Element {
    return (
      <Button
        className="u-mini-spacing-left"
        icon="compose"
        size={ButtonSize.SMALL}
        buttonStyle={ButtonStyle.SECONDARY}
        text="Create members"
        onClick={this._handleClick}
      />
    );
  }
}
